export enum SearchSortEnum {
  MOST_RELEVANT = 'MOST_RELEVANT',
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  RECENTLY_UPDATED = 'RECENTLY_UPDATED'
}
